// TradingViewWidget.jsx
import React, { useEffect, useRef, memo } from 'react';

// Global flag to prevent multiple script insertions
let isScriptAdded = false;

function TradingViewWidget() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isScriptAdded) {
      const script = document.createElement("script");
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-stock-heatmap.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "exchanges": [],
          "dataSource": "SPX500",
          "grouping": "sector",
          "blockSize": "market_cap_basic",
          "blockColor": "change",
          "locale": "en",
          "symbolUrl": "",
          "colorTheme": "dark",
          "hasTopBar": false,
          "isDataSetEnabled": false,
          "isZoomEnabled": false,
          "hasSymbolTooltip": true,
          "isMonoSize": false,
          "isTransparent": true,
          "width": "100%",
          "height": 500
        }`;
      containerRef.current.appendChild(script);
      isScriptAdded = true;
    }

    // Cleanup function to remove the script if necessary
    return () => {
      // Optionally, remove the script when the component unmounts
      // This is usually not necessary unless you have specific cleanup needs
      // if (containerRef.current) {
      //   containerRef.current.innerHTML = "";
      //   isScriptAdded = false;
      // }
    };
  }, []);

  return (
    <div
      className="tradingview-widget-container"
      ref={containerRef}
      style={{
        height: "500px",
        padding: "10px",
        borderRadius: "16px",
        overflow: "hidden",
        background: "transparent", // Ensure container background is transparent
        // If you have a parent container with a background, it will show through
      }}
    >
      <div className="tradingview-widget-container__widget"></div>
      <div
        className="tradingview-widget-copyright"
        style={{ textAlign: "center", marginTop: "8px" }}
      >
        <a
          href="https://www.tradingview.com/"
          rel="noopener noreferrer"
          target="_blank"
          style={{ color: "#007bff" }}
        >
          <span className="blue-text"></span>
        </a>
      </div>
    </div>
  );
}

export default memo(TradingViewWidget);
